import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { verifyAddress } from '@web/utils';
import { env } from '@/env';
import { ButtonWithLoading } from '../ButtonWithLoading';

interface AddressValidationInputProps {
  setValue: (name: string, value: string) => void;
  setCoordinates: (coordinates: { lat: number; long: number }) => void;
}

const AddressValidationInput: React.FC<AddressValidationInputProps> = (
  props,
) => {
  const { setValue, setCoordinates } = props;
  const { t } = useTranslation();

  const [addressToValidate, setAddressToValidate] = useState<string>('');
  const [isLoading, setLoading] = useState<boolean>(false);
  const [addressValidationError, setAddressValidationError] =
    useState<string>('');

  const handleVerifyAddress = async () => {
    setLoading(true);

    try {
      const verifiedAddress = await verifyAddress(
        addressToValidate,
        env.VITE_GOOGLE_API_KEY,
      );
      const { isVerified, formattedAddress, postalAddress, coordinates } =
        verifiedAddress;

      if (isVerified && postalAddress) {
        setValue('addressLine1', postalAddress.addressLines[0]);
        setValue('addressPostcode', postalAddress.postalCode);
        setValue('addressLocality', postalAddress.locality);
        if (coordinates) setCoordinates(coordinates);
        setAddressToValidate('');
        setAddressValidationError('');
      } else {
        setAddressValidationError(
          'Validation error, please try again or enter manually',
        );
      }
      setLoading(false);
      console.log({ isVerified, formattedAddress, postalAddress });
    } catch (error) {
      console.log('error from verifyAddress', error);
    }
  };

  return (
    <div className="mt-1-0 flex w-full items-center justify-between">
      <div className="w-full mr-1-0">
        <input
          className="mb-0 block w-full appearance-none rounded-4-0 border border-grey-200 bg-grey-100 bg-opacity-50 p-1-0 text-1-6 leading-1-0 text-grey-800 focus:bg-white focus:outline-none"
          disabled={isLoading}
          value={addressToValidate}
          onChange={(e) => setAddressToValidate(e.target.value)}
          placeholder={t('global.search') ?? ''}
        />
        {addressValidationError && (
          <p className="absolute text-1-2 italic text-red">
            {addressValidationError}
          </p>
        )}
      </div>
      <ButtonWithLoading
        isLoading={isLoading}
        isDisabled={!addressToValidate}
        handleClick={handleVerifyAddress}
      />
    </div>
  );
};

export default AddressValidationInput;
